import { createContext, useCallback, useContext, useState } from 'react';
import { DialogScopeContext } from './DialogScopeContext';

const DialogContext = createContext({});

export const DialogProvider = ({ children }) => {
  // Now an array = stack
  const [dialogStack, setDialogStack] = useState([]);

  // Push a new dialog on the stack
  const openDialog = useCallback((DialogComponent, dialogProps = {}) => {
    return new Promise((resolve) => {
      setDialogStack((current) => [
        ...current,
        { component: DialogComponent, props: dialogProps, resolve },
      ]);
    });
  }, []);

  // Pop the top dialog (or a specific one if you pass an index/id)
  const closeDialog = useCallback(
    (returnData) => {
      setDialogStack((current) => {
        if (current.length === 0) return current;

        const top = current[current.length - 1];
        if (top.resolve) top.resolve(returnData);

        // remove the last item
        return current.slice(0, -1);
      });
    },
    []
  );

  return (
    <DialogContext.Provider value={{ openDialog }}>
      {children}

      {dialogStack.map(({ component: DialogComp, props }, index) => (
        <DialogScopeContext.Provider key={index} value="dialog">
          <DialogComp
            {...props}
            open={true}
            closeDialog={closeDialog}
            // optional: depth={index} for z‑index or animation timing
          />
        </DialogScopeContext.Provider>
      ))}
    </DialogContext.Provider>
  );
};

export const useDialog = () => useContext(DialogContext);
export default DialogContext;